import React from 'react';
import { Box } from '@mui/material';
import Dashboard from '../components/Dashboard/Dashboard';

const DashboardPage = () => {
  return (
    <Box>
      <Box sx={{ my: 2 }}>
        <Dashboard />
      </Box>
    </Box>
  );
};

export default DashboardPage;